import { HStack } from "@chakra-ui/react"
import UserAvatarStack from "@pathwright/ux/src/components/avatar/UserAvatarStack"
import IntersectionLazyLoad, {
  IntersectionLazyLoadProps
} from "@pathwright/ux/src/components/loading/IntersectionLazyLoad"
import {
  HomeCohortMembersFragment,
  HomeGroupFragment,
  useHomeCohortMembersLazyQuery
} from "@pathwright/graphql-client/src/generated"
import { PathCardSubtitle } from "./path/PathCard"

type GroupAvatarsProps = {
  group: HomeCohortMembersFragment | HomeGroupFragment
  showGroupName?: boolean
  fontColor?: "whiteAlpha.900" | "blackAlpha.900"
  lineClamp?: number
}

// Dumb component that accepts the group.
export const GroupAvatars = ({
  group,
  showGroupName,
  fontColor = "whiteAlpha.900",
  lineClamp
}: GroupAvatarsProps) => {
  const users = group.registrations?.edges?.map((edge) => edge?.node!.user!)

  return (
    (users?.length || showGroupName) && (
      <HStack pos="relative" gap={2}>
        {!!users?.length && (
          <UserAvatarStack
            size="2xs"
            user={group.user_registration?.user}
            users={users}
            total={group.registrations?.total || 0}
          />
        )}
        {showGroupName && (
          <PathCardSubtitle color={fontColor} lineClamp={lineClamp}>
            {group.name}
          </PathCardSubtitle>
        )}
      </HStack>
    )
  )
}

type GroupAvatarsContainerProps = {
  groupId: number
  fallback?: IntersectionLazyLoadProps["fallback"]
} & Omit<GroupAvatarsProps, "group">

// Container component that queries the group by id.
const GroupAvatarsContainer = ({
  groupId,
  fallback,
  ...rest
}: GroupAvatarsContainerProps) => {
  return (
    <IntersectionLazyLoad
      lazyQuery={useHomeCohortMembersLazyQuery({
        variables: {
          groupId: groupId
        }
      })}
      fallback={fallback}
    >
      {([_load, { data }]) => <GroupAvatars group={data.group} {...rest} />}
    </IntersectionLazyLoad>
  )
}

export default GroupAvatarsContainer
